import React, { useContext, useReducer, useEffect, useMemo } from 'react'
import { Box, TextField } from '@mui/material';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import Table, { TableHookPro } from '../Table';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import './conhecimentos.css'
import MegaAutoComplete from '../Utils/megautocomplete';
import { externalComponent } from '../AppRoutes';
import { api } from '../../services/api';

import { convertDateFormat } from '../Utils/functions';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { NumericFormat } from 'react-number-format';

import { formatCurrency, formatDate } from '../Utils/IntegerOnly';

const getcolumnsBoletoConhecimento = () => {
    const columns = []
    columns.push({ field: 'NumeroNota', headerName: 'CT-e', flex: 0.1, width: 100 })
    columns.push({ field: 'Empresa', headerName: 'Empresa', flex: 0.1, width: 100 })
    columns.push({ field: 'ClienteNFE', headerName: 'Transportadora', flex: 0.1, width: 100 })
    columns.push({
        field: 'DataEmissao', headerName: 'Emissão', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataEmissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'ValorContabil', headerName: 'Valor CT-e', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.ValorContabil)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'valor_notas_vinculadas_total', headerName: 'Valor Total NF-e', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.valor_notas_vinculadas_total)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'percentual_frete', headerName: 'Percentual Calculado', width: 150,
        renderCell: ({ value }) => {
            return (
                <Box>
                    <NumericFormat
                        value={value}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        suffix="%"
                        fixedDecimalScale
                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'percentual_frete_transportadora',
        headerName: 'Percentual Frete',
        width: 150,
        renderCell: ({ value }) => (
            <Box>
                {value && value !== "Não cadastrado" ? (
                    <NumericFormat
                        value={value}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        suffix="%"
                        fixedDecimalScale
                    />
                ) : (
                    "Não cadastrado"
                )}
            </Box>
        )
    })
    return columns
}

const getBoletoConhecimentos = async (setLoader, setState, state) => {
    setLoader(true)
    const res = await api.post(`/get_boleto_conhecimentos/`, state)
    if (res.status === 200) {
        setState({ rows: res.data, rowsReset: res.data })
    }
    setLoader(false)
}

const clearFilter = (state, setState, setLoader, getBoletoConhecimentos) => {
    const clearFilters = { rowsConhecimento: state.rowsReset, cteFilter: '', empresaFilter: '', transportadoraFilter: '', situacaoFilter: '', dtIni: '', dtFim: '' }
    setState(clearFilters)

    getBoletoConhecimentos(setLoader, setState, clearFilters)
}

const selectSituacao = {
    1: {
        "nome": "Conciliado",
        "id": "1",
    },
    2: {
        "nome": "Incorreto",
        "id": "2",
    }
}

const setInicialDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtIni: value });
}

const setFinalDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtFim: value });
}


const PercentualFrete = () => {

    const currentDate = new Date();
    const threeMonthsAgo = new Date();

    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth());

    threeMonthsAgo.setDate(1);

    const dtIni = convertDateFormat(threeMonthsAgo)
    const dtFim = convertDateFormat(currentDate)

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        cteFilter: '',
        transportadoraFilter: '',
        situacaoFilter: '2',
        empresaFilter: '',
        dtIni: dtIni,
        dtFim: dtFim,
        rowsReset: [],

    })

    const [tableBoletoConhecimento] = TableHookPro()

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        getBoletoConhecimentos(setLoader, setState, state)
    }, [])

    return (
        <>
            <Box className='nfsentrada-mainframe' sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%', overflow: 'auto', overflowX: 'hidden' }}>

                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>

                    <Box className='filter-items' sx={{ marginBottom: '2rem', alignItems: 'flex-end' }}>
                        <TextField
                            id="boletoConhecimentoCte"
                            type="text"
                            label="Núm. CTE"
                            size='small'
                            value={state.cteFilter}
                            onChange={(e) => { setState({ 'cteFilter': e.target.value }) }}
                            fullWidth={false}
                            sx={{ width: '9rem' }}
                        />

                        <Box className='item-profile-row' sx={{ width: '20rem' }} >
                            <MegaAutoComplete

                                id="conhecimentosFilial"
                                multiple={false}
                                value={state.empresaFilter}
                                onChange={(data) => { setState({ empresaFilter: data }) }}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresa'
                            />
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '20rem' }} >
                            <MegaAutoComplete

                                id="conciliacaoTransportadora"
                                multiple={false}
                                value={state.transportadoraFilter}
                                onChange={(data) => { setState({ transportadoraFilter: data }) }}
                                noOptionsText={'Digite para procurar uma transportadora'}
                                timeoutUrl='/frete/transportadoras'
                                timeoutParam='label'
                                label='Transportadora'
                            />
                        </Box>


                        <FormControl size="small" fullWidth={false} sx={{ width: '17rem' }}>
                            <InputLabel id="status-label">Situação</InputLabel>
                            <Select
                                fullWidth={false}
                                id="conciliacaoSituacao"
                                labelId="conciliacaoSituacao-label"
                                value={state.situacaoFilter}
                                label="Situação"
                                onChange={(e) => { setState({ 'situacaoFilter': e.target.value }) }}
                            >
                                {
                                    Object.entries(selectSituacao).map(([key, value]) => (
                                        <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <Box className='item-profile-row' sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Inicial:"
                                    size="small"
                                    value={dayjs(state.dtIni)}
                                    onChange={(e) => setInicialDate(e, setState)}
                                    format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Final:"
                                    size="small"
                                    value={dayjs(state.dtFim)}
                                    onChange={(e) => setFinalDate(e, setState)} format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                        </Box>

                    </Box>

                    <Box className='filter-buttons'>

                        <ColorButton onClick={() => getBoletoConhecimentos(setLoader, setState, state)} > Localizar </ColorButton>
                        <ColorButton onClick={() => clearFilter(state, setState, setLoader, getBoletoConhecimentos)} > Limpar filtros </ColorButton>

                    </Box>

                </Box>

                <Box sx={{ flex: .85, minHeight: 0 }}>
                    <Table
                        key='boleto-conhecimento-table-1'
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumnsBoletoConhecimento())}
                        rowHeight={30}
                        pro={true}
                        innerRef={tableBoletoConhecimento}
                        nameTable='tabelaBoletoConhecimento'
                        hideFooter={true}
                    />
                </Box>


            </Box>

        </>
    )
}

export default PercentualFrete;